export interface DocumentsSPReponse {
    id: number;
    fileName: string;
    sharePointUrl: string;
    status: DOCUMENT_STATUS;
    active: boolean;
    originalActive?: boolean;
    selected?: boolean;
    uploadedByName: string;
    uploadedDate: Date;
    approvedByName: string;
    approvedDate: Date;
    updatedByName: string;
    updatedDate: Date;
    comments: any[];
}

export interface DocumentsChangesRequest {
    id: number;
    isActive: boolean;
}

export enum DOCUMENT_STATUS {
  PENDING_INACTIVE = 0,
  PENDING_ACTIVE = 1,
  PENDING_UPLOAD = 2,
  APPROVED = 3,
  REJECTED = 4
}

export const DOCUMENT_STATUS_LABELS: { [key: number]: string } = {
  [DOCUMENT_STATUS.APPROVED]: "Approved",
  [DOCUMENT_STATUS.REJECTED]: "Rejected",
  [DOCUMENT_STATUS.PENDING_UPLOAD]: "Pending upload",
  [DOCUMENT_STATUS.PENDING_INACTIVE]: "Pending deactivate",
  [DOCUMENT_STATUS.PENDING_ACTIVE]: "Pending activate"
};
